/**
 * Converts a target string to a valid HTML target attribute value.
 * @param {string} target - The target string to convert.
 * @returns {'_blank' | '_self' | undefined} - Returns '_blank'
 */
const convertTarget = (target) => {
  if (target === 'NEW') return '_blank';
  if (target === 'SELF') return '_self';
  return undefined;
};

export default convertTarget;
